<template>
  <div>
    <form>
      <div>
        <p>
          <label style="margin-bottom: 5px;float:left;" for="duplicateName">{{
            $t("evenement.name")
          }}</label>
          <b-input
            id="duplicateName"
            v-model="rowDuplicate.name"
            name="duplicateName"
            @focus="$event.target.select()"
          />
        </p>
      </div>
      <div style="margin-top:20px; margin-bottom:20px; text-align:left">
        <b-checkbox
          v-if="outil === 'eventify'"
          v-model="parameters.eventKeepEvents"
          >{{ $t("duplicate.parameter.event.planning") }}</b-checkbox
        >

        <b-checkbox
          v-if="outil === 'eventify'"
          v-model="parameters.eventKeepAttendees"
          >{{ $t("duplicate.parameter.event.attendees") }}</b-checkbox
        >
      </div>
      <div>
        <button @click.prevent="duplicateEvenement" class="button">
          {{ $t("button.sauvegarder") }}
        </button>
      </div>
    </form>
    <b-loading is-full-page :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PopupDuplicate",
  data() {
    return {
      isLoading: false,
      parameters: {
        eventKeepAttendees: false,
        eventKeepEvents: false,
        sondKeepAnswers: false,
        sondKeepQuestions: false,
        quizzKeepAnswers: false,
        quizzKeepQuestions: false,
        proKeepInventory: false,
        textKeepQuestions: false,
        brainKeepPostits: false
      },
      rowDuplicate: JSON.parse(JSON.stringify(this.row))
    };
  },
  props: {
    outil: String,
    row: Object
  },
  created() {
    let date = new Date();
    this.rowDuplicate.name = `${this.rowDuplicate.name} (${this.$i18n.t(
      "evenement.duplicate.rename"
    )} ${date.getDate()}/${date.getMonth() +
      1} ${date.getHours()}:${date.getMinutes()})`;
  },
  methods: {
    duplicateEvenement(e) {
      this.isLoading = true;
      this.parameters.row = this.rowDuplicate;
      axios
        .post(
          `${process.env.URL_SSO_API}Duplicate/${this.outil}/${this.rowDuplicate.shortcut_moderateur}`,
          this.parameters
        )
        .then(response => {
          this.$store.commit("MODAL_DUPLICATE", {
            evenement: null,
            activeModalDuplicate: false
          });
          this.$store.commit(`CLEAR_SEARCH`);
          this.$store.dispatch("getEvenements");
          this.isLoading = false;
          this.$buefy.toast.open({
            type: "is-success",
            message: this.$i18n.t("evenement.duplicate.success")
          });
        });
    }
  }
};
</script>
<style scoped>
.button {
  border-radius: 0px;
  background-color: #424a60;
  font-size: 12px;
  color: white;
}
.button:hover {
  border-radius: 0px;
  background-color: #424a60;
  font-size: 12px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/event/components/Duplicate.vue